import { GqlError } from "@smp/graphql/types";

export const isGqlError = (error: any): error is GqlError =>
  "response" in error && Array.isArray(error.response.errors);
